import { template as _$template } from "solid-js/web";
import { use as _$use } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=shell__inset aria-hidden=true>`);
/**
 * The parked aeroplane inside VIEW AIRPLANES — a WebGPU canvas laid over the
 * well the 2D screen drew, tracking it through the shell's own letterbox
 * transform, the same overlay technique `career/AircraftInset.tsx` uses for
 * PERSONAL AIRCRAFT.
 *
 * What it is *not* any more is that screen's turntable. PERSONAL AIRCRAFT
 * composites a transparent model over `G-AERO.SCR`'s painted aerodrome; this
 * screen's original renders an actual aerodrome and stands the aeroplane on its
 * runway, so it drives `parked-preview.ts` instead (which explains the split in
 * its own header). The subject arrives the same way as before: no
 * `PersonalPaint` ever reaches it — this screen never applies the *player's*
 * repaint — and an ace's own colours come from a `modelId` that already names
 * the ace's baked scheme (`shell/plane-viewer-surface.ts`, `ace-livery.ts`)
 * rather than from a runtime repaint.
 *
 * Gated on there being a `subject` at all: `previewSubject()` returns
 * `undefined` until `VIEW WHOSE AIRPLANES?` has been answered, so no renderer —
 * and none of the GPU work of building an aerodrome — exists before that.
 */

import { createEffect, onCleanup } from "solid-js";
import "../career/aircraft-inset.css";
import { createParkedPreview } from "./parked-preview.ts";
export function PlaneViewerInset(props) {
  let host;
  let preview;
  onCleanup(() => {
    preview?.dispose();
    preview = undefined;
  });
  createEffect(() => {
    const box = props.box();
    if (!host) return;
    if (!box) {
      host.style.display = "none";
      return;
    }
    const subject = props.surface.previewSubject();
    if (!subject) {
      host.style.display = "none";
      return;
    }
    host.style.display = "block";
    host.style.left = `${box.left}px`;
    host.style.top = `${box.top}px`;
    host.style.width = `${box.width}px`;
    host.style.height = `${box.height}px`;
    preview ??= createParkedPreview(host);
    if (!preview) return;
    preview.resize(box.width, box.height);
    // Before `show`, so a change to ENHANCED MODELS has already invalidated the
    // cached subject by the time the reload is asked for.
    preview.setEffects(props.effects());
    preview.show(subject.modelId);
    preview.setPose(subject.pose);
  });
  return (() => {
    var _el$ = _tmpl$();
    _$use(element => host = element, _el$);
    return _el$;
  })();
}